import { isGroupingColumn } from '@thoughtspot/visualization-column-util';
export class ContextMenuInputPoint {
    constructor() {
        this.selectedAttributes = [];
        this.deselectedAttributes = [];
        this.selectedMeasures = [];
        this.deselectedMeasures = [];
    }
    pushSelected(inputValue) {
        if (isGroupingColumn(inputValue.column)) {
            this.selectedAttributes.push(inputValue);
        }
        else {
            this.selectedMeasures.push(inputValue);
        }
    }
    pushDeselected(inputValue) {
        if (isGroupingColumn(inputValue.column)) {
            this.deselectedAttributes.push(inputValue);
        }
        else {
            this.deselectedMeasures.push(inputValue);
        }
    }
    getAllColumnInputValues() {
        return [].concat(this.selectedAttributes, this.deselectedAttributes, this.selectedMeasures, this.deselectedMeasures);
    }
}
//# sourceMappingURL=types.js.map